export default {
  data: () => ({
    translations: {
      title: {
        el: 'Λειτουργία Εμφάνισης Ανταμοιβής',
        en: 'Reward Display Mode',
        it: 'Modalità di visualizzazione delle ricompense',
      },
      rewardDisplay: {
        el: 'Εμφάνισης Ανταμοιβής',
        en: 'Display',
        it: 'Visualizza',
      },
      points: {
        el: 'Πόντοι',
        en: 'Points',
        it: 'Punti',
      },
      cashback: {
        el: 'Cashback',
        en: 'Cashback',
        it: 'Cashback',
      },
    },
  }),
};
